import { render } from "./Input.vue?vue&type=template&id=0e665ce4"
import script from "./Input.vue?vue&type=script&lang=ts"
export * from "./Input.vue?vue&type=script&lang=ts"
script.render = render

export default script